var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/arrow-up"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.2005 26.3328C32.8839 26.3328 32.5672 26.2161 32.3172 25.9661L21.4505 15.0995C20.6505 14.2995 19.3505 14.2995 18.5505 15.0995L7.68385 25.9661C7.20052 26.4495 6.40052 26.4495 5.91719 25.9661C5.43385 25.4828 5.43385 24.6828 5.91719 24.1995L16.7839 13.3328C18.5505 11.5661 21.4339 11.5661 23.2172 13.3328L34.0839 24.1995C34.5672 24.6828 34.5672 25.4828 34.0839 25.9661C33.8339 26.1995 33.5172 26.3328 33.2005 26.3328Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.8cba7dc69dbe3b8915d9b50a344942e6.svg";
export { ForwardRef as ReactComponent };